(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7937],{

/***/ 33690:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]/[year]/[month]/[day]/[slug]",
      function () {
        return __webpack_require__(87108);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/Shared/RecordNotFound/RecordNotFound.tsx
var RecordNotFound = __webpack_require__(56755);
;// CONCATENATED MODULE: ./components/Shared/RecordNotFound/Rerouting.tsx

var Rerouting = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-center mb-4 mt-4 w_sm_100 mx-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                children: "Rerouting(إعادة التوجيه)..."
            })
        })
    });
};
/* harmony default export */ var RecordNotFound_Rerouting = (Rerouting);

// EXTERNAL MODULE: ./lib/dfp/index.js
var dfp = __webpack_require__(37993);
// EXTERNAL MODULE: ./lib/dfp/util.js
var util = __webpack_require__(18879);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/Shared/SkeletonLoader/SkeletoLoader.tsx
var SkeletoLoader = __webpack_require__(58663);
// EXTERNAL MODULE: ./components/NewsLayout/VideoNewsLayout/VideoNewsLayout.tsx
var VideoNewsLayout = __webpack_require__(93270);
// EXTERNAL MODULE: ./components/NewsLayout/ArticleNewsLayout/ArticleNewsLayout.tsx
var ArticleNewsLayout = __webpack_require__(42169);
;// CONCATENATED MODULE: ./pages/[id]/[year]/[month]/[day]/[slug].tsx










var Index = function(props) {
    var news = props.news, metaData = props.metaData;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)([]), specialCategories = ref[0], setSpecialCatgories = ref[1];
    var ref1 = (0,react.useState)(true), urlok = ref1[0], setUrlok = ref1[1];
    (0,react.useEffect)(function() {
        (0,util/* DefineSlotsInnerPage */.M3)();
        return function() {
            router.events.off("routeChangeComplete", dfp/* removeSlot */.ac);
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        var sponsoredCategories = news === null || news === void 0 ? void 0 : (ref = news.categories) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.isSponsoredCategory) == true;
        });
        setSpecialCatgories(sponsoredCategories);
        if ((sponsoredCategories === null || sponsoredCategories === void 0 ? void 0 : sponsoredCategories.length) > 0) {
            router.push("/sector/news/" + router.query.id + "/" + router.query.slug);
        }
        var location = {
            "city": props.city,
            "country": props.country
        };
        if (true) {
            localStorage.setItem("userLocation", JSON.stringify(location));
        }
    }, [
        props
    ]);
    return Object.keys(news).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: urlok == false ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordNotFound_Rerouting, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: (specialCategories === null || specialCategories === void 0 ? void 0 : specialCategories.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletoLoader["default"], {
                    count: 30
                })
            }) : (news === null || news === void 0 ? void 0 : news.contentType) == "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoNewsLayout/* default */.Z, {
                news: news,
                metaData: metaData
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleNewsLayout/* default */.Z, {
                news: news,
                metaData: metaData
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordNotFound/* default */.Z, {});
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3325,6453,2614,6391,4035,1967,7592,8879,8235,5204,8961,8268,7164,4747,2086,6896,9774,2888,179], function() { return __webpack_exec__(33690); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);